import billingDetailsComponent from './components/billing.details.component';
import customerDetailsComponent from './components/customer.details.component';
import paymentDetailsComponent from './components/payment.details.component';
import countrySelectorComponent from './components/country.selector.component';
import paymentRequestButtonComponent from './components/payment.requestButton.component';

import countrySelectorController from './controllers/country.selector.controller';
import paymentDetailsController from './controllers/payment.details.controller';
import customerDetailsController from './controllers/customer.details.controller';
import paymentRequestButtonController from './controllers/payment.requestButton.controller';

import paymentTokenService from './services/payment.token.service';
import cardActionService from './services/card.action.service';
import paysafeErrorService from './services/paysafe.error.service';
import paymentGatewayService from './services/payment.gateway.service';
import paysafeGatewayService from './services/paysafe.gateway.service';
import paymentErrorService from './services/payment.error.service';
import stripeGatewayService from './services/stripe.gateway.service';

import paymentConnectService from './services/payment.connect.service';

const paymentModule = angular.module('journey-ui.shared.payment', [ 'journey-ui.shared.core' ])
  .component('billingDetails', billingDetailsComponent)
  .component('countrySelector', countrySelectorComponent)
  .component('customerDetails', customerDetailsComponent)
  .component('paymentDetails', paymentDetailsComponent)
  .component('paymentRequestButton', paymentRequestButtonComponent)

  .controller('countrySelectorController', countrySelectorController)
  .controller('paymentDetailsController', paymentDetailsController)
  .controller('customerDetailsController', customerDetailsController)
  .controller('paymentRequestButtonController', paymentRequestButtonController)

  .factory('paymentTokenService', paymentTokenService)
  .factory('cardActionService', cardActionService)
  .factory('paymentGatewayService', paymentGatewayService)
  .factory('paymentConnectService', paymentConnectService)
  .factory('paymentErrorService', paymentErrorService)
  .factory('paysafeGatewayService', paysafeGatewayService)
  .factory('stripeGatewayService', stripeGatewayService)
  .factory('paysafeErrorService', paysafeErrorService);

export default paymentModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/index.js